// extracted by mini-css-extract-plugin
export default {"container":"DraggableTemplate_container__7g8pn"};